<template>
  <div class="news-detail">
    <div class="news-left">
      <div class="news-title">
        {{list[id].title}}
      </div>
      <div class="news-date-row">
        <span>{{$t('time')}}: {{list[id].date}}</span>
      </div>
      <div class="news-content">
        <div class="news-content-item" v-for="(item,index) in list[id].conLength" :key="index">
          <div class="news-part" v-for="(paragraph, index) in $t(`news${id}.des${index + 1}`).split('\n')" :key="index">{{ paragraph }}</div>
          <img :src="require(`../assets/news/news${id}_${index + 1}.png`)" alt="">
          <div class="img-title">{{$t(`news${id}.img${index + 1}`)}}</div>
        </div>
        <template  v-if="list[id].lastDes" >
          <div class="news-part" v-for="(paragraph, index) in list[id].lastDes.split('\n')" :key="index">{{ paragraph }}</div>
        </template>
      </div>
    </div>
    <div class="news-right">
      <div class="tj-title">{{$t('related_news')}}</div>
      <template v-for="(item,key,index) in list">
        <div v-if="id != key" :key="index" class="tj-box" @click="goDetail(key)">
          <div class="tj-img-box">
            <img :src="require(`../assets/news/news${key}.png`)" alt="">
            <div class="tj-date">{{item.date}}</div>
          </div>
          <div class="tj-cont-tit">{{item.title}}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  beforeRouteUpdate(to, from, next) {
    if (to.query.id !== from.query.id) {
      this.id = to.query.id
    }
    next();
  },
  name: 'NewsDetail',
  data() {
    return {
      id:"",
      list: {
        1:{
          title:this.$t('news1.title'),
          date:this.$t('news1.time'),
          conLength:3,
          lastDes:this.$t('news1.lastDes')
        },
        2:{
          title:this.$t('news2.title'),
          date:this.$t('news2.time'),
          conLength:8,
        },
        
        // 3:{
        //   title:this.$t('news3.title'),
        //   date:"2017.09.20",
        //   conLength:4,
        //   lastDes:this.$t('news3.lastDes')
        // }
      },
      tjList:[],
      info:{}
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  methods: {
    goDetail(id) {
      this.$router.push('/news/detail?id=' + id)
    }
  }
}
</script>
<style scoped lang="scss">
.news-detail {
  display: flex;
  padding-bottom: 40px;
  .news-left {
    flex: 1;
    .news-title {
      font-weight: bold;
      font-size: 46px;
      color: #FFFFFF;
      line-height: 48px;
      margin-top: 77px;
    }
    .news-date-row {
      font-weight: 400;
      font-size: 15px;
      color: #FEFEFE;
      opacity: 0.52;
      margin-top: 90px;
      margin-bottom: 22px;
      padding-bottom: 32px;
      border-bottom: 1px solid rgba(255,255,255,0.22);
      span {
        margin-right: 60px;
      }
    }
    .news-content {
      white-space: pre-line; /* 保留换行符 */
      .news-part {
        font-weight: 400;
        font-size: 18px;
        color: #FEFEFE;
        line-height: 48px;
        text-indent: 2em;
      }
      .news-content-item {
        img {
          width: 100%;
          margin-top: 60px;
        }
        .img-title {
          text-align: center;
          margin-bottom: 20px;
          margin-top: 20px;
          font-weight: 400;
          font-size: 18px;
          color: #FEFEFE;
        }
      }
    }
  }
  .news-right {
    width: 24%;
    margin-left: 90px;
    .tj-title {
      font-weight: bold;
      font-size: 40px;
      color: #FFFFFF;
      padding-left: 8px;
      border-left: 9px solid #920307;
      margin-top: 70px;
      margin-bottom: 80px;
    }
    .tj-box {
      cursor: pointer;
      img {
        width: 100%;
      }
      .tj-img-box {
        position: relative;
      }
      .tj-date {
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 120px;
        height: 40px;
        background: #004DA9;
        font-weight: bold;
        font-size: 17px;
        color: #FEFEFE;
        font-style: italic;
        line-height: 40px;
        text-align: center;
      }
      .tj-cont-tit {
        margin: 42px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>